<header>
    <h1>
        <a [routerLink]="'/admin'"></a>
    </h1>
    <div id="lnb">
        <nav>
            <ul class="navbar">
                <li><a [routerLink]="'/admin/recruit'" >채용알림</a></li>
                <li><a [routerLink]="'/admin/notice'" >알림</a></li>
                <li><a [routerLink]="'/admin/adminInfo'" >Admin Info.</a></li>
                <li><a  id="logout">Logout</a></li>
            </ul>
        </nav>
    </div>
</header>